import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/** Builds the config to fetch a single environment variable by name. */
export function buildEnvironmentVariableConfig(envVarName: string): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.ENVIRONMENT_CONFIG,
    body: { envVarName },
  };
}

/** Builds the config to fetch multiple environment variables by name. */
export function buildEnvironmentVariablesConfig(envVarNames: string[]): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.ENVIRONMENT_CONFIG,
    body: { envVarNames },
  };
}
